import React from "react";
import "./Lock.scss";
import eventTracking from '../../utils/eventTracking';
import chapters from '../../utils/chaptersStepTranslation';

function Lock(props) {
  const text = `Kildesorter klassens drikkekartonger, så kan dere åpne kapittel ${chapters[props.progress]}`;
  function onClick() {
    props.handleModal(props.progress);
    eventTracking(
      `Kapittel ${chapters.offset[props.progress]}`,
      'Hengelås',
      'Steg 1'
    );
  }

  return (
    <div
      className="lock"
      data-text={text}
      onClick={() => onClick()}
    >
      <div className="the-lock"></div>
    </div>
  );
}

export default Lock;

